module.exports = {
    'Init': require('./init'),
    'LoadMore': require('./load-more'),
    'Search': require('./search')
};